var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { width: "500" },
      model: {
        value: _vm.show,
        callback: function ($$v) {
          _vm.show = $$v
        },
        expression: "show",
      },
    },
    [
      _c(
        "v-card",
        { staticClass: "modal-limit", attrs: { flat: "" } },
        [
          _c(
            "v-toolbar",
            { attrs: { color: "primary", dark: "", flat: "" } },
            [
              _c("v-toolbar-title", [_vm._v("Benefícios")]),
              _vm._v(" "),
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { icon: "" },
                  on: {
                    click: function ($event) {
                      return _vm.close()
                    },
                  },
                },
                [_c("v-icon", [_vm._v("close")])],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("h3", { staticClass: "gray--text" }, [
            _vm._v("\n      " + _vm._s(_vm.currentTitle) + "\n    "),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "limit-msg" }, [
            !_vm.hasBalance
              ? _c("span", { staticClass: "red--text pl-3 pb-3" }, [
                  _vm._v(
                    "\n        * Você não possui saldo suficiente para realizar esse resgate.\n      "
                  ),
                ])
              : _vm._e(),
          ]),
          _vm._v(" "),
          _vm.rewardDetails
            ? _c(
                "div",
                _vm._l(_vm.itemsToRedeem, function (item, index) {
                  return _c(
                    "v-flex",
                    { key: index, staticClass: "modal-limit-area" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "content",
                          class:
                            item.quantity > 0 && _vm.hasBalance
                              ? "active-border"
                              : "",
                        },
                        [
                          _c("div", { staticClass: "first-item" }, [
                            _c("img", {
                              staticClass: "mr-2",
                              attrs: { src: item.img, width: "30" },
                            }),
                            _vm._v(" "),
                            _c(
                              "h4",
                              {
                                staticClass: "mr-2",
                                class: {
                                  active: !(
                                    item.cost > _vm.currentBalanceNumber
                                  ),
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(item.title) +
                                    "\n            "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("span", { staticClass: "trigger" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(item.trigger) +
                                  "\n            "
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("AppInputPlusMinus", {
                            attrs: {
                              disabled:
                                item.cost > _vm.currentBalanceNumber ||
                                !_vm.hasBalance,
                            },
                            on: {
                              "plus-value": function ($event) {
                                return _vm.plusQuantity(item)
                              },
                              "minus-value": function ($event) {
                                return _vm.minusQuantity(item)
                              },
                            },
                            model: {
                              value: _vm.model[item.title],
                              callback: function ($$v) {
                                _vm.$set(_vm.model, item.title, $$v)
                              },
                              expression: "model[item.title]",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      item.cost > _vm.currentBalanceNumber
                        ? _c("span", { staticClass: "message" }, [
                            _vm._v(
                              "\n          Compre mais com a UPL para liberar este benefício\n        "
                            ),
                          ])
                        : _vm._e(),
                    ]
                  )
                }),
                1
              )
            : _c("PreviewRewards", { attrs: { items: _vm.itemsToRedeem } }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "btn-container mt-3 pb-3" },
            [
              _c(
                "v-btn",
                {
                  staticClass: "white--text",
                  attrs: {
                    disabled: _vm.disabledAction || !_vm.hasBalance,
                    color: "primary",
                  },
                  on: { click: _vm.nextStep },
                },
                [
                  _vm._v(
                    "\n        " + _vm._s(_vm.currentStep.button) + "\n      "
                  ),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "info-message" }, [
                _c("span", { staticClass: "gray--text" }, [
                  _vm._v(
                    "\n          *imagens meramente ilustrativas\n        "
                  ),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "gray--text" }, [
                  _vm._v(
                    "\n          Os valores podem variar, de acordo com entrega\n        "
                  ),
                ]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }